import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { scale } from '@components/frame';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { selectSelectedItem } from '@reducers/machines';
import { Machine } from '@interfaces/machines';
import ImagesContainer, { ImagesContainerMode } from '@v2/pages/common/components/ImagesContainer/ImagesContainer';
import { useGetPreselectedScopeIds } from '@v2/pages/common/hooks/useGetPreselectedScopeIds';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { MACHINES_NOW_OVERVIEW_BLOCK_CONFIG, TOP_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { OnTopBlockImagePressProp } from '@v2/pages/machines/modules/now/components/Overview/components/TopBlock/types';

const TopBlockImages: FC<OnTopBlockImagePressProp> = ({ onTopBlockImagePress }) => {
  const preselectedScopeIds = useGetPreselectedScopeIds();
  const selectedMachine: Machine = useSelector(selectSelectedItem);
  const productionBatchId = selectedMachine?.machineStatus?.productionBatchId;

  const { maxWidth } = MACHINES_NOW_OVERVIEW_BLOCK_CONFIG;
  const { paddingVertical } = TOP_BLOCK_CONFIG;

  return (
    <View style={{ paddingVertical: scale(paddingVertical) }}>
      <ImagesContainer
        maxDetailsWidth={scale(maxWidth)}
        panelViewMode={false}
        mode={ImagesContainerMode.ROW}
        documentRetrieveId={productionBatchId}
        documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Batch}
        onImagePress={onTopBlockImagePress}
        containerBorderRadiusConfig={{
          borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
          borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
        }}
        noBorder
        preselectedScopeIds={preselectedScopeIds}
      />
    </View>
  );
};

export default TopBlockImages;
